<div class="row  platform-page-background mb-4">

  <nav id="mainNav" class="navbar navbar-expand-lg navbar-light fixed-top">
    <div class="container mw-1400">
      <a data-testid="auto-app-iframe-searchtoolbox-a-1" class="navbar-brand z2 test1" href="https://www.webbtree.com/" target="_blank"><img src="../../../assets/webtree.png" alt="Webbtree"
          title="Webbtree"></a>
      <a data-testid="auto-app-iframe-searchtoolbox-a-2" class="navbar-brand z2 test3" href="https://www.webbtree.com/" target="_blank"><img src="../../../assets/webbtree-white.png" alt="Webbtree"
          title="Webbtree"></a>
      <!-- <a data-testid="auto-app-iframe-searchtoolbox-a-3" class="navbar-brand" href="#">Navbar</a> -->
      <!-- <button data-testid="auto-app-iframe-searchtoolbox-button-1" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button> -->
      <a data-testid="auto-app-iframe-searchtoolbox-a-4" href="https://staging.webbtree.com/signup" target="_blank"
              class="btn signup-outline my-sm-0 font-weight-500 z2" role="button">Sign Up</a>

      <!-- <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a data-testid="auto-app-iframe-searchtoolbox-a-5" href="https://staging.webbtree.com/signup" target="_blank"
              class="btn signup-outline my-sm-0 font-weight-500 z2" role="button">Sign Up</a>
          </li>
        </ul>
      </div> -->
    </div>
  </nav>


  <!-- Vertically centered modal -->
  <header class="allfeatureHeader d-flex justify-content-start align-items-end position-relative">
    <div class="container mw-1400">
      <h1 class="f-32 font-weight-500 text-left text-white">X-ray searching across the web</h1>
      <p class="f-18 mb-6 pb-4 text-white">Find candidate from across the web based on search parameters such as - skills,
        job titles, locations,
        companies.</p>
          <div class="tablistConatainer">
      <ul class="nav nav-pills  searchCandidate" id="pills-tab" role="tablist">

        <li class="nav-item" role="presentation">
          <a data-testid="auto-app-iframe-searchtoolbox-a-6" class="nav-link" [ngClass]="{'active': tabToShow == 'LinkedIn'}" id="pills-linkedin-tab" data-bs-toggle="pill"
            href="#pills-linkedin" role="tab" aria-controls="pills-linkedin" aria-selected="true"><i
              class="fab mr-1 fa-linkedin"></i> Linkedin</a>
        </li>

        <li class="nav-item" role="presentation">
          <a data-testid="auto-app-iframe-searchtoolbox-a-7" class="nav-link ml-5" [ngClass]="{'active': tabToShow == 'Xing'}" id="pills-xing-tab" data-bs-toggle="pill"
            href="#pills-xing" role="tab" aria-controls="pills-xing" aria-selected="false"><i
              class="fab mr-1 fa-xing-square"></i> Xing</a>
        </li>

        <li class="nav-item" role="presentation">
          <a data-testid="auto-app-iframe-searchtoolbox-a-8" class="nav-link ml-5" [ngClass]="{'active': tabToShow == 'Quora'}" id="pills-quora-tab" data-bs-toggle="pill"
            href="#pills-quora" role="tab" aria-controls="pills-quora" aria-selected="false"><i
              class="fab mr-1 fa-quora"></i> Quora</a>
        </li>

        <li class="nav-item" role="presentation">
          <a data-testid="auto-app-iframe-searchtoolbox-a-9" class="nav-link ml-5" [ngClass]="{'active': tabToShow == 'GitHub'}" id="pills-gitHub-tab"
            data-bs-toggle="pill" href="#pills-gitHub" role="tab" aria-controls="pills-gitHub" aria-selected="false"><i
              class="fab mr-1 fa-github"></i> Github</a>
        </li>

        <li class="nav-item" role="presentation">
          <a data-testid="auto-app-iframe-searchtoolbox-a-10" class="nav-link ml-5" [ngClass]="{'active': tabToShow == 'Stack Overflow'}" id="pills-stackOverflow-tab"
            data-bs-toggle="pill" href="#pills-stackOverflow" role="tab" aria-controls="pills-stackOverflow"
            aria-selected="false"><i class="fab mr-1 fa-stack-overflow"></i> Stackoverflow</a>
        </li>

        <li class="nav-item" role="presentation">
          <a data-testid="auto-app-iframe-searchtoolbox-a-11" class="nav-link ml-5" id="pills-behance-tab" [ngClass]="{'active': tabToShow == 'Behance'}"
            data-bs-toggle="pill" href="#pills-behance" role="tab" aria-controls="pills-behance" aria-selected="false"><i
              class="fab mr-1 fa-behance-square"></i> Behance</a>
        </li>

        <li class="nav-item" role="presentation">
          <a data-testid="auto-app-iframe-searchtoolbox-a-12" class="nav-link ml-5" id="pills-twitter-tab" [ngClass]="{'active': tabToShow == 'Twitter'}"
            data-bs-toggle="pill" href="#pills-twitter" role="tab" aria-controls="pills-twitter" aria-selected="false"><i
              class="fa-brands mr-1 fa-square-x-twitter" style="color: rgb(6, 6, 6);"></i> Twitter</a>
        </li>

      </ul>
    </div>
    </div>
  </header>

</div>


<div class="container mw-1400">
  <div class="row">
    <div class="tab-content  platform-page-background col-md-8 pb-6 mb-6 px-xs-0" id="pills-tabContent">
      <!-- LinkedIn -->
      <div class="tab-pane fade" id="pills-linkedin" role="tabpanel" aria-labelledby="pills-linkedin-tab"
        [ngClass]="{'show active': tabToShow == 'LinkedIn'}">

        <div class="col wccard mb-3px pb-8">
          <!-- Input Fields -->
          <div class="row">
            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions"
                  [style]="{'width':'100%'}" (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')"
                  placeholder="E.g. Java developer"
                  (onSelect)="selectAutoCompleteChip($event, 'Job Title')"
                  (onUnselect)="removeSelectedChip($event,'Job Title')"
                  (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
              </div>

              <div class="mt-4" *ngIf="recommendedjobtitle.length>0">
                <div class="customChip mr-1 mt-1" (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');" *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                title="{{jobtitle}}">
                <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip"
                  class="text-danger">*</span> (Include profiles with any of
                these skills) </label>
              <ng-template #preferredSkillsTooltip>
                <span class="f-12"> Select at least 1 preferred skill </span>
              </ng-template>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                  [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')"
                  placeholder="Type minimum 3 characters to get suggestions"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"
                  (onUnselect)="removeSelectedChip($event,'Skill')"
                  (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
              </div>
                <div class="mt-4" *ngIf="recommendedskills.length>0">
                <div class="customChip mr-1 mt-1"  (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                title="{{skills}}">
                <div class="chipname" name="skills">{{skills}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
               </div>
               </div>
            </div>
          </div>

          <!-- Suggestions Row -->
          <!-- <div class="row mb-4" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
            <div class="col-md-6">
              <div class="customChip mr-1 mt-1 " *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                title="{{jobtitle}}">
                <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                    (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');"></i> </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="customChip mr-1 mt-1 " *ngFor="let skills of recommendedskills ;let i = index"
                title="{{skills}}">
                <div class="chipname" name="skills">{{skills}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                    (click)="addRecommendedSuggestionChip(i , skills, 'Skill');"></i> </div>
              </div>
            </div>
          </div> -->

          <div class="row">
            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills)
              </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption"
                  [style]="{'width':'100%'}" (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"
                  (onUnselect)="removeSelectedChip($event,'Skill')" (onSelect)="selectAutoCompleteChip($event, 'Skill')"
                  placeholder="Type minimum 3 characters to get suggestions"
                  (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
              </div>
              <div class="mt-4" *ngIf="recommendedskills.length>0">
                <div class="">
                  <div class="customChip mr-1 mt-1" (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')"
                  placeholder="E.g. Mumbai"
                  (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
              </div>
            </div>
          </div>

          <!-- <div class="row mb-4" *ngIf="recommendedskills.length>0">
            <div class="col-md-6">
              <div class="customChip mr-1 mt-1 " *ngFor="let skills of recommendedskills ;let i = index"
                title="{{skills}}">
                <div class="chipname" name="skills">{{skills}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                    (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');"></i> </div>
              </div>
            </div>
          </div> -->

          <div class="row">
            <div class="col-md-6  mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Target Companies </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="companies" [suggestions]="filteredCompanyOption" [style]="{'width':'100%'}"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Company')"
                  placeholder="Type minimum 3 characters to get suggestions" field="company_name"
                  (completeMethod)="searchAutoCompletedData($event , 'Company')" [multiple]="true">
                  <ng-template let-companies pTemplate="item">
                    <div class="country-item">
                      <div class="font-weight-500 text-capitalize">{{companies.company_name}}</div>
                      <p class="text-capitalize font-weight-400 greybg f-12">{{companies.industry_name}}</p>
                    </div>
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>

            <div class="col-md-6  mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Industries </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="industry" [suggestions]="filteredIndustryOption" [style]="{'width':'100%'}"
                  (completeMethod)="searchAutoCompletedData($event , 'Industry')"
                  placeholder="Type minimum 3 characters to get suggestions"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Industry')" [multiple]="true">
                </p-autoComplete>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6  mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Institutes </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="institute" [suggestions]="filteredInstituteOption"
                  [style]="{'width':'100%'}" (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Institute')"
                  placeholder="Type minimum 3 characters to get suggestions"
                  (completeMethod)="searchAutoCompletedData($event , 'Institute')" [multiple]="true"></p-autoComplete>
              </div>
            </div>

            <div class="col-md-6  mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Spoken Languages </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="spokenLanguage" [suggestions]="filteredSpokenLanguageOption"
                  [style]="{'width':'100%'}" (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'SpokenLanguage')"
                  placeholder="Type minimum 1 character to get suggestions"
                  (completeMethod)="searchAutoCompletedData($event , 'SpokenLanguage')" [multiple]="true">
                </p-autoComplete>
              </div>
            </div>
          </div>

          <div>
            <button data-testid="auto-app-iframe-searchtoolbox-button-2" class="btn-trms-medium m-auto"
              (click)="googleCustomSearchAPI('initial', 'linkedInSearch')">Search
              talents on LinkedIn</button>
            &nbsp; &nbsp;
            <button data-testid="auto-app-iframe-searchtoolbox-button-3" class="btn-trms-white" (click)="resetAllFields()">Clear All</button>
          </div>

          <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError"> <br /> Please select at least 1 preferred
            skill
          </div>
        </div>
      </div>

      <!-- Xing -->
      <div class="tab-pane fade" id="pills-xing" role="tabpanel" aria-labelledby="pills-xing-tab"
        [ngClass]="{'show active': tabToShow == 'Xing'}">
        <div class="col wccard mb-3px pb-8">
          <!-- Input Fields -->
          <div class="row">
            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions"
                  [style]="{'width':'100%'}" (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')"
                  placeholder="E.g. Java developer"
                  (onSelect)="selectAutoCompleteChip($event, 'Job Title')"
                  (onUnselect)="removeSelectedChip($event,'Job Title')"
                  (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
              </div>
                <div class="mt-4" *ngIf="recommendedjobtitle.length>0">
                  <div class="">
                    <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');" *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                      title="{{jobtitle}}">
                      <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                      <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                    </div>
                  </div>
                </div>
            </div>

            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip"
                  class="text-danger">*</span> (Include profiles with any of
                these skills) </label>
              <ng-template #preferredSkillsTooltip>
                <span class="f-12"> Select at least 1 preferred skill </span>
              </ng-template>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                  [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')"
                  placeholder="Type minimum 3 characters to get suggestions"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"
                  (onUnselect)="removeSelectedChip($event,'Skill')"
                  (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
              </div>
              <div class="mt-4" *ngIf="recommendedskills.length>0">
                <div class="">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Suggestions Row -->
          <!-- <div class="row mb-4" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
            <div class="col-md-6">
              <div class="customChip mr-1 mt-1 " *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                title="{{jobtitle}}">
                <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                    (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');"></i> </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="customChip mr-1 mt-1 " *ngFor="let skills of recommendedskills ;let i = index"
                title="{{skills}}">
                <div class="chipname" name="skills">{{skills}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                    (click)="addRecommendedSuggestionChip(i , skills, 'Skill');"></i> </div>
              </div>
            </div>
          </div> -->

          <div class="row">
            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills)
              </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption"
                  [style]="{'width':'100%'}" (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"
                  (onUnselect)="removeSelectedChip($event,'Skill')" (onSelect)="selectAutoCompleteChip($event, 'Skill')"
                  placeholder="Type minimum 3 characters to get suggestions"
                  (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
              </div>

              <div class="mt-4" *ngIf="recommendedskills.length>0">
                <div class="">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')"
                  placeholder="E.g. Mumbai"
                  (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
              </div>
            </div>
          </div>

          <!-- <div class="row mb-4" *ngIf="recommendedskills.length>0">
            <div class="col-md-6">
              <div class="customChip mr-1 mt-1 " *ngFor="let skills of recommendedskills ;let i = index"
                title="{{skills}}">
                <div class="chipname" name="skills">{{skills}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                    (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');"></i> </div>
              </div>
            </div>
          </div> -->

          <div class="row">
            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Target Companies </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="companies" [suggestions]="filteredCompanyOption" [style]="{'width':'100%'}"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Company')"
                  placeholder="Type minimum 3 characters to get suggestions" field="company_name"
                  (completeMethod)="searchAutoCompletedData($event , 'Company')" [multiple]="true">
                  <ng-template let-companies pTemplate="item">
                    <div class="country-item">
                      <div class="font-weight-500 text-capitalize">{{companies.company_name}}</div>
                      <p class="text-capitalize font-weight-400 greybg f-12">{{companies.industry_name}}</p>
                    </div>
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>

            <div class="col-md-6 mb-4 ">
              <label class="font-weight-500 f-12 mb-1 mt-3">Industries </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="industry" [suggestions]="filteredIndustryOption" [style]="{'width':'100%'}"
                  (completeMethod)="searchAutoCompletedData($event , 'Industry')"
                  placeholder="Type minimum 3 characters to get suggestions"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Industry')" [multiple]="true">
                </p-autoComplete>
              </div>
            </div>
          </div>

          <div>
            <button data-testid="auto-app-iframe-searchtoolbox-button-4" class="btn-trms-medium " (click)="googleCustomSearchAPI('initial', 'xingSearch')">Search
              talents on Xing</button>
            &nbsp; &nbsp;
            <button data-testid="auto-app-iframe-searchtoolbox-button-5" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
          </div>

          <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError"> <br /> Please select at least 1 preferred
            skill
          </div>
        </div>

      </div>

      <!-- Quora -->
      <div class="tab-pane fade" id="pills-quora" role="tabpanel" aria-labelledby="pills-quora-tab"
        [ngClass]="{'show active': tabToShow == 'Quora'}">

        <div class="col wccard mb-3px pb-8">
          <!-- Input Fields -->
          <div class="row">
            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions"
                  [style]="{'width':'100%'}" (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')"
                  placeholder="E.g. Java developer"
                  (onSelect)="selectAutoCompleteChip($event, 'Job Title')"
                  (onUnselect)="removeSelectedChip($event,'Job Title')"
                  (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
              </div>
              <div class="mt-4" *ngIf="recommendedjobtitle.length>0">
                <div class="">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');" *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                    title="{{jobtitle}}">
                    <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip"
                  class="text-danger">*</span> (Include profiles with any of
                these skills) </label>
              <ng-template #preferredSkillsTooltip>
                <span class="f-12"> Select at least 1 preferred skill </span>
              </ng-template>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                  [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')"
                  placeholder="Type minimum 3 characters to get suggestions"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"
                  (onUnselect)="removeSelectedChip($event,'Skill')"
                  (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
              </div>
              <div class="mt-4" *ngIf="recommendedskills.length>0">
                <div class="">
                  <div class="customChip mr-1 mt-1" (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Suggestions Row -->
          <!-- <div class="row mb-4" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
            <div class="col-md-6">
              <div class="customChip mr-1 mt-1 " *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                title="{{jobtitle}}">
                <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                    (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');"></i> </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="customChip mr-1 mt-1 " *ngFor="let skills of recommendedskills ;let i = index"
                title="{{skills}}">
                <div class="chipname" name="skills">{{skills}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                    (click)="addRecommendedSuggestionChip(i , skills, 'Skill');"></i> </div>
              </div>
            </div>
          </div> -->

          <div class="row">
            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills)
              </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption"
                  [style]="{'width':'100%'}" (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"
                  (onUnselect)="removeSelectedChip($event,'Skill')" (onSelect)="selectAutoCompleteChip($event, 'Skill')"
                  placeholder="Type minimum 3 characters to get suggestions"
                  (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
              </div>
              <div class="mt-4" *ngIf="recommendedskills.length>0">
                <div class="">
                  <div class="customChip mr-1 mt-1" (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')"
                  placeholder="E.g. Mumbai"
                  (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
              </div>
            </div>
          </div>

          <!-- <div class="row mb-4" *ngIf="recommendedskills.length>0">
            <div class="col-md-6">
              <div class="customChip mr-1 mt-1 " *ngFor="let skills of recommendedskills ;let i = index"
                title="{{skills}}">
                <div class="chipname" name="skills">{{skills}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                    (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');"></i> </div>
              </div>
            </div>
          </div> -->

          <div class="row">
            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Target Companies </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="companies" [suggestions]="filteredCompanyOption" [style]="{'width':'100%'}"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Company')"
                  placeholder="Type minimum 3 characters to get suggestions" field="company_name"
                  (completeMethod)="searchAutoCompletedData($event , 'Company')" [multiple]="true">
                  <ng-template let-companies pTemplate="item">
                    <div class="country-item">
                      <div class="font-weight-500 text-capitalize">{{companies.company_name}}</div>
                      <p class="text-capitalize font-weight-400 greybg f-12">{{companies.industry_name}}</p>
                    </div>
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>
          </div>

          <div>
            <button data-testid="auto-app-iframe-searchtoolbox-button-6" class="btn-trms-medium m-auto" (click)="googleCustomSearchAPI('initial', 'quoraSearch')">Search
              talents on Quora</button>
            &nbsp; &nbsp;
            <button data-testid="auto-app-iframe-searchtoolbox-button-7" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
          </div>

          <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError"> <br /> Please select at least 1 preferred
            skill
          </div>
        </div>

      </div>

      <!-- Twitter -->
      <div class="tab-pane fade" id="pills-twitter" role="tabpanel" aria-labelledby="pills-twitter-tab"
        [ngClass]="{'show active': tabToShow == 'Twitter'}">

        <div class="col wccard mb-3px pb-8">
          <!-- Input Fields -->
          <div class="row">
            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions"
                  [style]="{'width':'100%'}" (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')"
                  placeholder="E.g. Java developer"
                  (onSelect)="selectAutoCompleteChip($event, 'Job Title')"
                  (onUnselect)="removeSelectedChip($event,'Job Title')"
                  (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
              </div>
              <div class="mt-4" *ngIf="recommendedjobtitle.length>0">
                <div class="">
                  <div class="customChip mr-1 mt-1" (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');" *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                    title="{{jobtitle}}">
                    <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>

              </div>
            </div>

            <div class="col-md-6">
              <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip"
                  class="text-danger">*</span> (Include profiles with any of
                these skills) </label>
              <ng-template #preferredSkillsTooltip>
                <span class="f-12"> Select at least 1 preferred skill </span>
              </ng-template>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                  [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')"
                  placeholder="Type minimum 3 characters to get suggestions"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"
                  (onUnselect)="removeSelectedChip($event,'Skill')"
                  (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
              </div>
              <div class="mt-4" *ngIf="recommendedskills.length>0">
                <div class="">
                  <div class="customChip mr-1 mt-1 " (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Suggestions Row -->
          <!-- <div class="row mb-4" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
            <div class="col-md-6">
              <div class="customChip mr-1 mt-1 " *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                title="{{jobtitle}}">
                <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                    (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');"></i> </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="customChip mr-1 mt-1 " *ngFor="let skills of recommendedskills ;let i = index"
                title="{{skills}}">
                <div class="chipname" name="skills">{{skills}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                    (click)="addRecommendedSuggestionChip(i , skills, 'Skill');"></i> </div>
              </div>
            </div>
          </div> -->

          <div class="row">
            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills)
              </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption"
                  [style]="{'width':'100%'}" (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"
                  (onUnselect)="removeSelectedChip($event,'Skill')" (onSelect)="selectAutoCompleteChip($event, 'Skill')"
                  placeholder="Type minimum 3 characters to get suggestions"
                  (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
              </div>
              <div class="mt-4" *ngIf="recommendedskills.length>0">
                <div class="">
                  <div class="customChip mr-1 mt-1"  (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')"
                  placeholder="E.g. Mumbai"
                  (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
              </div>
            </div>
          </div>

          <!-- <div class="row mb-4" *ngIf="recommendedskills.length>0">
            <div class="col-md-6">
              <div class="customChip mr-1 mt-1 " *ngFor="let skills of recommendedskills ;let i = index"
                title="{{skills}}">
                <div class="chipname" name="skills">{{skills}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                    (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');"></i> </div>
              </div>
            </div>
          </div> -->

          <div class="row">
            <div class="col-md-6  mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Target Companies </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="companies" [suggestions]="filteredCompanyOption" [style]="{'width':'100%'}"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Company')"
                  placeholder="Type minimum 3 characters to get suggestions" field="company_name"
                  (completeMethod)="searchAutoCompletedData($event , 'Company')" [multiple]="true">
                  <ng-template let-companies pTemplate="item">
                    <div class="country-item">
                      <div class="font-weight-500 text-capitalize">{{companies.company_name}}</div>
                      <p class="text-capitalize font-weight-400 greybg f-12">{{companies.industry_name}}</p>
                    </div>
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>

          </div>

          <div>
            <button data-testid="auto-app-iframe-searchtoolbox-button-8" class="btn-trms-medium m-auto"
              (click)="googleCustomSearchAPI('initial', 'twitterSearch')">Search
              talents on Twitter</button>
            &nbsp; &nbsp;
            <button data-testid="auto-app-iframe-searchtoolbox-button-9" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
          </div>
          <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError"> <br /> Please select at least 1 preferred
            skill
          </div>
        </div>
      </div>

      <!-- GitHub -->
      <div class="tab-pane fade" id="pills-gitHub" role="tabpanel" aria-labelledby="pills-gitHub-tab"
        [ngClass]="{'show active': tabToShow == 'GitHub'}">

        <div class="col wccard mb-3px pb-8">
          <!-- Input Fields -->
          <div class="row">
            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills)
              </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption"
                  [style]="{'width':'100%'}" (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"
                  (onUnselect)="removeSelectedChip($event,'Skill')" (onSelect)="selectAutoCompleteChip($event, 'Skill')"
                  placeholder="Type minimum 3 characters to get suggestions"
                  (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
              </div>
              <div class="mt-4" *ngIf="recommendedjobtitle.length>0 ">
                <div class="">
                  <div class="customChip mr-1 mt-1" (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip"
                  class="text-danger">*</span> (Include profiles with any of
                these skills) </label>
              <ng-template #preferredSkillsTooltip>
                <span class="f-12"> Select at least 1 preferred skill </span>
              </ng-template>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                  [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')"
                  placeholder="Type minimum 3 characters to get suggestions"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"
                  (onUnselect)="removeSelectedChip($event,'Skill')"
                  (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
              </div>
              <div class="mt-4" *ngIf="recommendedskills.length>0">
                <div class="">
                  <div class="customChip mr-1 mt-1"  (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Suggestions Row -->
          <!-- <div class="row mb-4" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
            <div class="col-md-6">
              <div class="customChip mr-1 mt-1 " *ngFor="let skills of recommendedskills ;let i = index"
                title="{{skills}}">
                <div class="chipname" name="skills">{{skills}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                    (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');"></i> </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="customChip mr-1 mt-1 " *ngFor="let skills of recommendedskills ;let i = index"
                title="{{skills}}">
                <div class="chipname" name="skills">{{skills}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                    (click)="addRecommendedSuggestionChip(i , skills, 'Skill');"></i> </div>
              </div>
            </div>
          </div> -->

          <div class="row">
            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')"
                  placeholder="E.g. Mumbai"
                  (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
              </div>
            </div>

            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Programming Languages </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="programmingLanguage" [suggestions]="filteredProgrammingLanguageOption"
                  [style]="{'width':'100%'}"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'ProgrammingLanguage')"
                  placeholder="Type minimum 1 character to get suggestions"
                  (completeMethod)="searchAutoCompletedData($event , 'ProgrammingLanguage')" [multiple]="true">
                </p-autoComplete>
              </div>
            </div>
          </div>



          <div>
            <button data-testid="auto-app-iframe-searchtoolbox-button-10" class="btn-trms-medium m-auto" (click)="googleCustomSearchAPI('initial', 'githubSearch')">Search
              talents on GitHub</button>
            &nbsp; &nbsp;
            <button data-testid="auto-app-iframe-searchtoolbox-button-11" class="btn-trms-white  m-auto" (click)="resetAllFields()">Clear All</button>
          </div>

          <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError"> <br /> Please select at least 1 preferred
            skill
          </div>
        </div>

      </div>

      <!-- Stack Overflow -->
      <div class="tab-pane fade" id="pills-stackOverflow" role="tabpanel" aria-labelledby="pills-stackOverflow-tab"
        [ngClass]="{'show active': tabToShow == 'Stack Overflow'}">

        <div class="col wccard mb-3px pb-8">
          <!-- Input Fields -->
          <div class="row">
            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions"
                  [style]="{'width':'100%'}" (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')"
                  placeholder="E.g. Java developer"
                  (onSelect)="selectAutoCompleteChip($event, 'Job Title')"
                  (onUnselect)="removeSelectedChip($event,'Job Title')"
                  (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
              </div>
              <div class="mt-4" *ngIf="recommendedjobtitle.length>0">
                <div class="">
                  <div class="customChip mr-1 mt-1" (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');" *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                    title="{{jobtitle}}">
                    <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip"
                  class="text-danger">*</span> (Include profiles with any of
                these skills) </label>
              <ng-template #preferredSkillsTooltip>
                <span class="f-12"> Select at least 1 preferred skill </span>
              </ng-template>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                  [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')"
                  placeholder="Type minimum 3 characters to get suggestions"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"
                  (onUnselect)="removeSelectedChip($event,'Skill')"
                  (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
              </div>
              <div class="mt-4" *ngIf="recommendedskills.length>0">
                <div class="">
                  <div class="customChip mr-1 mt-1" (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Suggestions Row -->
          <!-- <div class="row mb-4" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
            <div class="col-md-6">
              <div class="customChip mr-1 mt-1 " *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                title="{{jobtitle}}">
                <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                    (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');"></i> </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="customChip mr-1 mt-1 " *ngFor="let skills of recommendedskills ;let i = index"
                title="{{skills}}">
                <div class="chipname" name="skills">{{skills}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                    (click)="addRecommendedSuggestionChip(i , skills, 'Skill');"></i> </div>
              </div>
            </div>
          </div> -->

          <div class="row">
            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills)
              </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption"
                  [style]="{'width':'100%'}" (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"
                  (onUnselect)="removeSelectedChip($event,'Skill')" (onSelect)="selectAutoCompleteChip($event, 'Skill')"
                  placeholder="Type minimum 3 characters to get suggestions"
                  (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
              </div>
              <div class="mt-4" *ngIf="recommendedskills.length>0">
                <div class="">
                  <div class="customChip mr-1 mt-1" (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')"
                  placeholder="E.g. Mumbai"
                  (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
              </div>
            </div>
          </div>

          <!-- <div class="row mb-4" *ngIf="recommendedskills.length>0">
            <div class="col-md-6">
              <div class="customChip mr-1 mt-1 " *ngFor="let skills of recommendedskills ;let i = index"
                title="{{skills}}">
                <div class="chipname" name="skills">{{skills}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                    (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');"></i> </div>
              </div>
            </div>
          </div> -->


          <div>
            <button data-testid="auto-app-iframe-searchtoolbox-button-12" class="btn-trms-medium m-auto"
              (click)="googleCustomSearchAPI('initial', 'stackOverflowSearch')">Search talents on Stack
              Overflow</button>
            &nbsp; &nbsp;
            <button data-testid="auto-app-iframe-searchtoolbox-button-13" class="btn-trms-white  m-auto" (click)="resetAllFields()">Clear All</button>
          </div>

          <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError"> <br /> Please select at least 1 preferred
            skill
          </div>
        </div>

      </div>

      <!-- Behance -->
      <div class="tab-pane fade" id="pills-behance" role="tabpanel" aria-labelledby="pills-behance-tab"
        [ngClass]="{'show active': tabToShow == 'Behance'}">

        <div class="col wccard mb-3px pb-8">
          <!-- Input Fields -->
          <div class="row">
            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Job Title </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="jobtitle" [suggestions]="filteredJobTitleOptions"
                  [style]="{'width':'100%'}" (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Job Title')"
                  placeholder="E.g. Java developer"
                  (onSelect)="selectAutoCompleteChip($event, 'Job Title')"
                  (onUnselect)="removeSelectedChip($event,'Job Title')"
                  (completeMethod)="searchAutoCompletedData($event , 'Job Title')" [multiple]="true"></p-autoComplete>
              </div>
              <div class="mt-4" *ngIf="recommendedjobtitle.length>0">
                <div class="">
                  <div class="customChip mr-1 mt-1"  (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');" *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                    title="{{jobtitle}}">
                    <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                       ></i> </div>
                  </div>
                </div>

              </div>
            </div>

            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Preferred Skills<span [ngbTooltip]="preferredSkillsTooltip"
                  class="text-danger">*</span> (Include profiles with any of
                these skills) </label>
              <ng-template #preferredSkillsTooltip>
                <span class="f-12"> Select at least 1 preferred skill </span>
              </ng-template>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="preferredskills" [suggestions]="filteredSkillsOption"
                  [style]="{'width':'100%'}" (onSelect)="selectAutoCompleteChip($event, 'Skill')"
                  placeholder="Type minimum 3 characters to get suggestions"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Skill')"
                  (onUnselect)="removeSelectedChip($event,'Skill')"
                  (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
              </div>
              <div class="mt-4" *ngIf="recommendedskills.length>0">
                <div class="">
                  <div class="customChip mr-1 mt-1" (click)="addRecommendedSuggestionChip(i , skills, 'Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Suggestions Row -->
          <!-- <div class="row mb-4" *ngIf="recommendedjobtitle.length>0 || recommendedskills.length>0">
            <div class="col-md-6">
              <div class="customChip mr-1 mt-1 " *ngFor="let jobtitle of recommendedjobtitle ;let i = index"
                title="{{jobtitle}}">
                <div class="chipname" name="jobtitle">{{jobtitle}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                    (click)="addRecommendedSuggestionChip(i , jobtitle, 'Job Title');"></i> </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="customChip mr-1 mt-1 " *ngFor="let skills of recommendedskills ;let i = index"
                title="{{skills}}">
                <div class="chipname" name="skills">{{skills}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                    (click)="addRecommendedSuggestionChip(i , skills, 'Skill');"></i> </div>
              </div>
            </div>
          </div> -->

          <div class="row">
            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Mandatory Skills (Include profiles with all these skills)
              </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="mandatoryskills" [suggestions]="filteredSkillsOption"
                  [style]="{'width':'100%'}" (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Mandatory Skill')"
                  (onUnselect)="removeSelectedChip($event,'Skill')" (onSelect)="selectAutoCompleteChip($event, 'Skill')"
                  placeholder="Type minimum 3 characters to get suggestions"
                  (completeMethod)="searchAutoCompletedData($event , 'Skill')" [multiple]="true"></p-autoComplete>
              </div>
              <div class="mt-4" *ngIf="recommendedskills.length>0">
                <div class="">
                  <div class="customChip mr-1 mt-1"  (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');" *ngFor="let skills of recommendedskills ;let i = index"
                    title="{{skills}}">
                    <div class="chipname" name="skills">{{skills}}</div>
                    <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"></i> </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 mb-4">
              <label class="font-weight-500 f-12 mb-1 mt-3">Locations </label>
              <div class="position-relative">
                <p-autoComplete [(ngModel)]="location" [suggestions]="filteredLocationOption" [style]="{'width':'100%'}"
                  (onKeyUp)="addSuggestionChipOnClickingEnter($event , 'Location')"
                  placeholder="E.g. Mumbai"
                  (completeMethod)="searchAutoCompletedData($event , 'Location')" [multiple]="true"></p-autoComplete>
              </div>
            </div>
          </div>

          <!-- <div class="row mb-4" *ngIf="recommendedskills.length>0">
            <div class="col-md-6">
              <div class="customChip mr-1 mt-1 " *ngFor="let skills of recommendedskills ;let i = index"
                title="{{skills}}">
                <div class="chipname" name="skills">{{skills}}</div>
                <div class="ml-2 pointer"> <i class="far fa-plus" aria-hidden="true"
                    (click)="addRecommendedSuggestionChip(i , skills, 'Mandatory Skill');"></i> </div>
              </div>
            </div>
          </div> -->

          <div class="row mb-4">
            <div class="col-md-6 d-flex align-items-center mb-2">
              <div class="position-relative">
                <label class="wc-checkbox mr-3 mb-0">
                  <input data-testid="auto-app-iframe-searchtoolbox-input-1" type="checkbox" id="resumeCheckbox" [(ngModel)]="showResultsWithResume" name="resumeCheckbox"
                    (click)="showResumeCheckbox($event);">
                  <i class="fas fa-check"></i>
                </label>
                <label for="resumeCheckbox" class="font-weight-500 f-12 mb-1 mt-3">Show profiles with Resume </label>
              </div>
            </div>
          </div>

          <div>
            <button data-testid="auto-app-iframe-searchtoolbox-button-14" class="btn-trms-medium m-auto"
              (click)="googleCustomSearchAPI('initial', 'behanceSearch')">Search talents on Behance</button>
            &nbsp; &nbsp;
            <button data-testid="auto-app-iframe-searchtoolbox-button-15" class="btn-trms-white m-auto" (click)="resetAllFields()">Clear All</button>
          </div>

          <div class="mb-3 mt-3 f-14 form-error" *ngIf="showFormError"> <br /> Please select at least 1 preferred
            skill
          </div>
        </div>

      </div>

    </div>

    <div class="col-md-4 mb-6 px-xs-0">
      <div class="card bg-white p-3 shadow-sm border-1px-green">
        <p class="f-16 font-weight-500 mb-2">What does this help me with?</p>
        <table>
          <tr>
            <td valign="top"><i class="fal fa-check"></i></td>
            <td class="pl-2">
              <p class="mb-2">Easily perform X-Ray search and get candidates across the web in this platform.</p>
            </td>
          </tr>
          <tr>
            <td valign="top"><i class="fal fa-check"></i></td>
            <td class="pl-2">
              <p class="mb-2">Get candidates from multiple websites in one platform</p>
            </td>
          </tr>
          <tr>
            <td valign="top"><i class="fal fa-check"></i></td>
            <td class="pl-2">
              <p class="mb-2">Narrow down your search and spot candidates with the preferable qualifications and
                skills.</p>
            </td>
          </tr>
          <tr>
            <td valign="top"><i class="fal fa-check"></i></td>
            <td class="pl-2">
              <p class="mb-2">Use this tool to search and view candidates anyways.</p>
            </td>
          </tr>
          <tr>
            <td valign="top"><i class="fal fa-check"></i></td>
            <td class="pl-2">
              <p class="mb-4">See candidates that are not in your network on Linkedin.</p>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>

<section  id="resultsSectionDiv">
<div class="container mw-1400 px-xs-0 mb-6" *ngIf="showSearchResults">
  <div class="wccard p-4">
    <div class="user-selected-options-div">

      <div *ngIf="showUserSelectedJobTitles" class="row mb-1 justify-content-between">
        <div class="col-md-8">
          <span class="pb-0 mb-1 f-14 mr-2">
            <span class="gray-text mr-2"> Job Titles: </span>
            <span class="f-14"> {{userSelectedData.jobtitles }} </span>
          </span>
        </div>
      </div>

      <div *ngIf="showUserSelectedPreferredSkills" class="row mb-1 justify-content-between">
        <div class="col-md-8">
          <span class="pb-0 mb-1 f-14 mr-2">
            <span class="gray-text mr-2"> Preferred Skills: </span>
            <span class="f-14"> {{userSelectedData.preferredskills }} </span>
          </span>
        </div>
      </div>

      <div *ngIf="showUserSelectedMandatorySkills" class="row mb-1 justify-content-between">
        <div class="col-md-8">
          <span class="pb-0 mb-1 f-14 mr-2">
            <span class="gray-text mr-2"> Mandatory Skills: </span>
            <span class="f-14"> {{userSelectedData.mandatoryskills }} </span>
          </span>
        </div>
      </div>

      <div *ngIf="showUserSelectedLocations" class="row mb-1 justify-content-between">
        <div class="col-md-8">
          <span class="pb-0 mb-1 f-14 mr-2">
            <span class="gray-text mr-2"> Location Names: </span>
            <span class="f-14"> {{userSelectedData.locations }} </span>
          </span>
        </div>
      </div>

      <div *ngIf="showUserSelectedCompanies" class="row mb-1 justify-content-between">
        <div class="col-md-8">
          <span class="pb-0 mb-1 f-14 mr-2">
            <span class="gray-text mr-2"> Company Names: </span>
            <span class="f-14"> {{userSelectedData.companies }} </span>
          </span>
        </div>
      </div>

      <div *ngIf="showUserSelectedInstitutes" class="row mb-1 justify-content-between">
        <div class="col-md-8">
          <span class="pb-0 mb-1 f-14 mr-2">
            <span class="gray-text mr-2"> Institutes: </span>
            <span class="f-14"> {{userSelectedData.schools }} </span>
          </span>
        </div>
      </div>


      <div *ngIf="showUserSelectedGender" class="row mb-1 justify-content-between">
        <div class="col-md-8">
          <span class="pb-0 mb-1 f-14 mr-2">
            <span class="gray-text mr-2"> Gender: </span>
            <span class="f-14"> {{userSelectedData.gender }} </span>
          </span>
        </div>
      </div>


      <div *ngIf="showUserSelectedEducationalDegrees" class="row mb-1 justify-content-between">
        <div class="col-md-8">
          <span class="pb-0 mb-1 f-14 mr-2">
            <span class="gray-text mr-2"> Educational Degrees: </span>
            <span class="f-14"> {{userSelectedData.educationaldegrees }} </span>
          </span>
        </div>
      </div>

      <div *ngIf="showUserSelectedIndustries" class="row mb-1 justify-content-between">
        <div class="col-md-8">
          <span class="pb-0 mb-1 f-14 mr-2">
            <span class="gray-text mr-2"> Industry Sector: </span>
            <span class="f-14"> {{userSelectedData.industries }} </span>
          </span>
        </div>
      </div>


      <div *ngIf="showUserSelectedSpokenLanguages" class="row mb-1 justify-content-between">
        <div class="col-md-8">
          <span class="pb-0 mb-1 f-14 mr-2">
            <span class="gray-text mr-2"> Spoken Languages: </span>
            <span class="f-14"> {{userSelectedData.spokenlanguages }} </span>
          </span>
        </div>
      </div>

      <div *ngIf="showUserSelectedProgrammingLanguages" class="row mb-1 justify-content-between">
        <div class="col-md-8">
          <span class="pb-0 mb-1 f-14 mr-2">
            <span class="gray-text mr-2"> Programming Skills: </span>
            <span class="f-14"> {{userSelectedData.programminglanguages }} </span>
          </span>
        </div>
      </div>

      <div *ngIf="showUserSelectedResumeOption" class="row mb-1 justify-content-between">
        <div class="col-md-8">
          <span class="pb-0 mb-1 f-14 mr-2">
            <span class="gray-text mr-2"> Show profiles with Resume: </span>
            <span class="f-14"> Yes </span>
          </span>
        </div>
      </div>
    </div>
    <br>

    <div *ngIf="totalSearchResultsCount ==  0"> <br />
      <p>No result found. Please modify your Search Filters.</p>
    </div>

    <div [ngClass]="{'SearchScroll': searchResults.length > 10}" *ngIf="totalSearchResultsCount > 0">
      <p class="font-weight-500"> {{totalSearchResultsCount}} Candidates Found </p>
      <div *ngFor="let x of searchResults">
        <div class="d-flex">
          <div class="canProfilePic">
            <img *ngIf="(x.pagemap && x.pagemap.cse_thumbnail && x.pagemap.cse_thumbnail.length > 0)"
              src="{{x.pagemap.cse_thumbnail[0].src}}" alt="None" class="img-search">
            <i class="fas fa-user-circle  fa-5x img-search"
              *ngIf="!(x.pagemap && x.pagemap.cse_thumbnail && x.pagemap.cse_thumbnail.length > 0)"></i>
          </div>
          <div class="col">
            <a data-testid="auto-app-iframe-searchtoolbox-a-13" href="{{x?.formattedUrl}}" target="_blank" class="font-weight-600 text-capitalize search-title"
              [innerHtml]="x.htmlTitle">
            </a>
            <p><span class="ml7px f-12 font-weight-500" [innerHtml]="x.htmlSnippet"></span></p>
          </div>
        </div>
        <br /><br />
      </div>
      <section class="position-relative">
        <div *ngFor="let x of searchResults"  class="blurred-div">
          <div class="d-flex">
            <div class="canProfilePic">
              <img *ngIf="(x.pagemap && x.pagemap.cse_thumbnail && x.pagemap.cse_thumbnail.length > 0)"
                src="{{x.pagemap.cse_thumbnail[0].src}}" alt="None" class="img-search">
              <i class="fas fa-user-circle  fa-5x img-search"
                *ngIf="!(x.pagemap && x.pagemap.cse_thumbnail && x.pagemap.cse_thumbnail.length > 0)"></i>
            </div>
            <div class="col">
              <a data-testid="auto-app-iframe-searchtoolbox-a-14" href="{{x?.formattedUrl}}" target="_blank" class="font-weight-600 text-capitalize search-title"
                [innerHtml]="x.htmlTitle">
              </a>
              <p><span class="ml7px f-12 font-weight-500" [innerHtml]="x.htmlSnippet"></span></p>
            </div>
          </div>
          <br /><br />
        </div>

        <div class="center-signup">
          <button data-testid="auto-app-iframe-searchtoolbox-button-16" class="btn-trms-small m-auto"
          (click)="Redirect2signup()">Sign up </button>
        </div>

      </section>

    </div>
</div>
</div>
</section>

<section class="footer position-relative mt-6">
  <footer class="container mw-1400">
      <div class="row pt-5 d-flex flex-column flex-sm-row">
          <div class="col">
              <p><a data-testid="auto-app-iframe-searchtoolbox-a-15" class="navbar-brand z2" href="https://www.webbtree.com/index.html"><img src="./assets/webbtree-white.png" alt="Webbtree"
                          title="Webbtree"></a>
              </p>
              <p class="text-white f-16">We believe businesses thrive when they are able to find and nurture the
                  right talent and we're building a solution that empowers organizations to do just that.
              </p>
              <p class="f-14 font-weight-600 text-white">Follow us <span><a data-testid="auto-app-iframe-searchtoolbox-a-16" href="https://www.facebook.com/webbtreeapp/"
                          target="_blank" class="text-white"> <i class="fab fa-facebook f-20 ml-5"></i></a><a data-testid="auto-app-iframe-searchtoolbox-a-17"
                          href="https://www.linkedin.com/company/webbtree/" target="_blank" class="text-white"> <i
                              class="fab fa-linkedin f-20 ml-5"></i></a><a data-testid="auto-app-iframe-searchtoolbox-a-18" href="https://twitter.com/Webbtreeapp/" target="_blank"
                          class="text-white"> <i class="fa-brands fa-square-x-twitter ml-5 f-20"></i></a></span>
              </p>
          </div>
          <div class="d-flex px-3">
              <div>
                  <p class="f-14 font-weight-600 text-white"><a data-testid="auto-app-iframe-searchtoolbox-a-19" href="https://www.webbtree.com/talent-pipelining-and-sourcing.html" target="_blank"
                          class="text-white">Talent pipelining and sourcing</a></p>
                  <p class="f-14 font-weight-600 text-white"><a data-testid="auto-app-iframe-searchtoolbox-a-20" href="https://www.webbtree.com/applicant-tracking-system.html" target="_blank"
                          class="text-white">Applicant tracking system</a></p>
                  <p class="f-14 font-weight-600 text-white"><a data-testid="auto-app-iframe-searchtoolbox-a-21" href="https://www.webbtree.com/contactus.html"  target="_blank" class="text-white">Contact
                          us</a></p>
                  <p class="f-14 font-weight-600 text-white"><a data-testid="auto-app-iframe-searchtoolbox-a-22" href="https://webbtree.freshdesk.com/support/solutions"
                          target="_blank" class="text-white">Help</a></p>
              </div>
          </div>
      </div>
  </footer>
  <hr class="text-white border-bottom-gray">
  <div class="container py-2 mw-1400">
      <div class="row d-flex flex-column flex-column-reverse flex-sm-row">
          <div class="col-md-6">
              <p class="f-14 font-weight-600 text-white">© 2020 Webbtree All rights reserved</p>
          </div>
          <div class="col d-flex justify-content-sm-end ">
              <p class="f-14 font-weight-600 text-white"><span><a data-testid="auto-app-iframe-searchtoolbox-a-23" href="terms-and-conditions.html" class="text-white">Terms
                          & Conditions</a></span> <span class="ml-5"><a data-testid="auto-app-iframe-searchtoolbox-a-24" href="privacy-policy.html" class="text-white">Privacy
                          policy</a></span></p>
          </div>
      </div>
  </div>
</section>
